module.exports = __webpack_public_path__ + "static/media/coinbase_wallet.7ac87212.svg";